import { render, staticRenderFns } from "./ExportManuscriptPdfDialog.vue?vue&type=template&id=07fa362b&scoped=true&"
import script from "./ExportManuscriptPdfDialog.vue?vue&type=script&lang=ts&"
export * from "./ExportManuscriptPdfDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ExportManuscriptPdfDialog.vue?vue&type=style&index=0&id=07fa362b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa362b",
  null
  
)

export default component.exports